// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SkypeFilledSvg from "@ant-design/icons-svg/es/asn/SkypeFilled";
import AntdIcon from '../components/AntdIcon';

var SkypeFilled = function SkypeFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SkypeFilledSvg
  }));
};

SkypeFilled.displayName = 'SkypeFilled';
export default React.forwardRef(SkypeFilled);